import { Flex } from '@chakra-ui/react';
import Card from 'components/card/Card';
import CheckTable from 'components/dataTables/CheckTable';
import { SidebarHelpContext } from 'contexts/SidebarHelpContext';
import { PlanningTypes } from 'pages/admin/demand/planning/context/types/contextPrevision.type';
import { useCallback, useContext, useEffect, useMemo } from 'react';

import { columnsDataViewPlanning } from './variables/columnsData';
interface IViewPlanningTable {
	completed: boolean;
	year: number;
	cycleId: number;
	cycle: number;
	isCurrent: boolean;
	companyAreaId?: number;
	companyAreaName?: string;
}
interface IViewPlanning {
	year: number;
	cycle_id: number;
	cycle: number;
	completed: boolean;
	is_current: boolean;
	company_area_id?: number;
	company_area_name?: string;
}
interface IViewPlanningProps {
	planningType: PlanningTypes;
	helpContent: any;
}
export default function ViewPlanning({
	planningType,
	helpContent,
}: IViewPlanningProps) {
	const { setters } = useContext(SidebarHelpContext);

	const { setDataSidebar } = setters;

	useEffect(() => {
		setDataSidebar(helpContent);
	}, [setDataSidebar, helpContent]);

	const renderRow = useCallback(
		(viewPlanning: IViewPlanning): IViewPlanningTable => {
			return {
				completed: viewPlanning.completed,
				year: viewPlanning.year,
				cycleId: viewPlanning.cycle_id,
				cycle: viewPlanning.cycle,
				isCurrent: viewPlanning.is_current,
				companyAreaId: viewPlanning.company_area_id,
				companyAreaName: viewPlanning.company_area_name,
			};
		},
		[]
	);

	const columnsData = useMemo(
		() => columnsDataViewPlanning(planningType),
		[planningType]
	);

	const renderTable = () => {
		return (
			<CheckTable
				dataTest={`button-filter-${planningType}`}
				module={planningType}
				columnsData={columnsData}
				showGenericSearchInput={false}
				filterModule={planningType}
				renderRow={renderRow}
				noButton
				pt={14}
				tableTest={`table-${planningType}`}
			/>
		);
	};

	return (
		<Flex
			direction='column'
			pt={{ sm: '125px', lg: '75px' }}
		>
			<Card>{renderTable()}</Card>
		</Flex>
	);
}
